import { ConfigProvider } from "antd";
import viVN from 'antd/locale/vi_VN';
import AuthProvider from "./AuthProvider";
import { Outlet } from "react-router";

export default function RootLayout() {
  return (
    <ConfigProvider locale={viVN}>
        <AuthProvider />
        <Outlet></Outlet>
    </ConfigProvider>
  );
}
